import { gql } from '@apollo/client';

export const UPDATE_UPPER_AIR_WEATHER_STATION = gql`
    mutation UpdateUpperAirWeatherStation($id: Guid!, $input: UpdateUpperAirWeatherStation!) {
        facility {
            process {
                updateUpperAirWeatherStation(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
